import React from "react";
import type { SVGProps } from "react";

export function AdvertiseIconSVG(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="#000"
        d="m383.46 123.668l-4.66 17.387C430.868 155.005 467 202.095 467 256s-36.133 100.994-88.2 114.945l4.66 17.387C443.31 372.295 485 317.962 485 256c0-61.963-41.69-116.295-101.54-132.332M307 147.102c-38.21 31.665-62.18 50.07-92.316 59.488c-30.27 9.46-65.937 10.324-129.684 10.4v78.02c63.747.076 99.415.94 129.684 10.4c30.136 9.418 54.107 27.823 92.316 59.488zm64.035 22.93l-4.658 17.388C397.46 195.748 419 223.822 419 256s-21.54 60.252-52.623 68.58l4.658 17.387C409.902 331.552 437 296.237 437 256s-27.098-75.552-65.965-85.967zm-12.424 46.364l-4.657 17.387C364.05 236.49 371 245.547 371 256s-6.95 19.51-17.047 22.217l4.658 17.387c17.885-4.792 30.392-21.09 30.392-39.604s-12.507-34.812-30.39-39.604zM67 216.998L60 217c-1.75 0-2.906.44-4.574 1.898c-1.668 1.46-3.578 4.104-5.2 7.756C46.977 233.96 45 245 45 256s1.978 22.04 5.225 29.346c1.623 3.652 3.533 6.296 5.2 7.756C57.096 294.562 58.25 295 60 295l7 .002zm258 17.316v43.372c3.018-.413 5.432-.966 6.975-1.737c2.39-1.196 3.554-2.3 4.8-5.104C338.022 268.04 339 263.25 339 256s-.978-12.04-2.225-14.846c-1.246-2.804-2.41-3.908-4.8-5.103c-1.543-.77-3.957-1.323-6.975-1.736zM87.533 313.027L115.027 423h62.252c-3.437-10.215-11.674-22.83-20.997-38.37c-11.1-18.5-22.693-41.56-24.824-71.13c-12.897-.304-27.38-.428-43.927-.473z"
      ></path>
    </svg>
  );
}
